<template>
  <b-card class="card">
    <b-form submite.stop.prevent="save">
      <b-overlay :show="isSaving" rounded="sm">
        <div v-if="user.Permissions.configurarquantidademoendas.allowed">
          <label for="" :title="$t('numberOfMills')">{{
            $t("numberOfMills")
          }}</label>
          <input
            type="number"
            min="1"
            max="3"
            v-model.lazy="numberOfMillings"
            id="numberOfMillings"
          />
        </div>
        <div
          class="mt-3"
          v-if="user.Permissions.configurarquantidademoendas.allowed"
        >
          <label for="" :title="$t('minimumTimeGrindingFactor')">{{
            $t("minimumTimeGrindingFactor")
          }}</label>
          <input
            @change="updatedMillingsFactorsChange"
            type="time"
            id="time"
            v-model="hourEnd"
          />
          <hr />
        </div>
        <div
          class="alertGrid"
          v-if="
            (infoMilling.totalMilling == -9999 ||
              infoMilling.calculateMilling == -9999) &&
            this.hourEnd < this.actualHour()
          "
        >
          <div class="alertTXT" :title="$t('insufficientData')">
            {{ $t("insufficientData") }}
          </div>
          <div class="alertTXT alertTXT2" :title="$t('changeFactorsManually')">
            {{ $t("changeFactorsManually") }}
          </div>
        </div>
        <hr
          v-if="
            (infoMilling.totalMilling == -9999 ||
              infoMilling.calculateMilling == -9999) &&
            this.hourEnd < this.actualHour()
          "
        />
        <div v-if="this.hourEnd > this.actualHour()" class="alertGrid">
          <div class="alertTXT alertTXT2" :title="$t('waitUntil')">
            {{ $t("waitUntil") }} {{ this.hourEnd }}
            {{ $t("hoursToChangeFactors") }}
          </div>
          <div
            class="alertTXT alertTXT2"
            :title="$t('canChangeFactorsManually')"
          >
            {{ $t("canChangeFactorsManually") }}
          </div>
        </div>
        <hr v-if="this.hourEnd > this.actualHour()" />
        <div v-if="this.hourEnd < this.actualHour()" class="mb-2">
          <label for="" :title="$t('calculatedGrinding')">
            {{ $t("calculatedGrinding") }}</label
          >
          <label
            v-if="infoMilling.calculateMilling != -9999"
            class="labelTXT"
            id="moagemCalculada"
            for=""
            >{{ infoMilling.calculateMilling }}</label
          >
          <label
            v-if="infoMilling.calculateMilling == -9999"
            class="labelTXT"
            id="moagemReal"
            for=""
          >
            -
          </label>
        </div>
        <div v-if="this.hourEnd < this.actualHour()" class="mb-2">
          <label for="" :title="$t('realGrinding')"
            >{{ $t("realGrinding") }}:</label
          >
          <label
            v-if="infoMilling.totalMilling != -9999"
            class="labelTXT"
            id="moagemReal"
            for=""
            >{{ infoMilling.totalMilling }}</label
          >
          <label
            v-if="infoMilling.totalMilling == -9999"
            class="labelTXT"
            id="moagemReal"
            for=""
          >
            -
          </label>
        </div>
        <div
          class="mb-2"
          v-if="
            infoMilling.totalMilling != -9999 &&
            infoMilling.calculateMilling != -9999 &&
            this.hourEnd < this.actualHour()
          "
        >
          <label for="" :title="$t('realAndCalculatedDifference')"
            >{{ $t("realAndCalculatedDifference") }}:</label
          >
          <label class="labelTXT" id="moagemReal">{{
            porcentagemDiferença
          }}</label>
        </div>
        <div
          class="mb-3"
          v-if="
            this.numberOfMillings == 1 ||
            this.numberOfMillings == 2 ||
            this.numberOfMillings == 3
          "
        >
          <label for="">{{ $t("correctionFactorA") }} </label>
          <input
            @keydown="updatedMillingsFactorsChange"
            v-model="factors.A"
            id="fatorA"
            type="text"
          />
        </div>
        <div
          class="mb-3"
          v-if="this.numberOfMillings == 2 || this.numberOfMillings == 3"
        >
          <label for="">{{ $t("correctionFactorB") }}</label>
          <input
            @keydown="updatedMillingsFactorsChange"
            v-model="factors.B"
            id="fatorB"
            type="text"
          />
        </div>
        <div class="mb-4" v-if="this.numberOfMillings == 3">
          <label for="">{{ $t("correctionFactorC") }}</label>
          <input
            @keydown="updatedMillingsFactorsChange"
            v-model="factors.C"
            id="fatorC"
            type="text"
          />
        </div>

        <div class="mb-3">
          <label for="">{{ $t("intervalo-caculo-automatico-moagem") }}</label>
          <input
            class="inputDataGrid"
            type="number"
            v-model="automaticGrinding"
            @keydown="updatedMillingsFactorsChange"
          />
        </div>

        <hr />
        <section class="tableCalculationHistory">
          <b-table
            :items="items"
            :fields="fields"
            sticky-header="300px"
            head-variant="dark"
            hover
            small
          >
            <template #cell(dateTime)="data">
              <div>
                {{ formatDate(data.value) }}
              </div>
            </template>

            <template #cell(correctionfactorvalue)="data">
              <div>
                {{ data.value.toFixed(2) }}
              </div>
            </template>

            <template #cell(diferenca)="data">
              <div>
                {{ data.value.toFixed(2) }}
              </div>
            </template>

            <template #cell(millingreal)="data">
              <div>
                {{ data.value.toFixed(2) }}
              </div>
            </template>d

            <template #cell(millingcalculation)="data">
              <div>
                {{ data.value.toFixed(2) }}
              </div>
            </template>

            <template #cell(typecalc)="data">
              <div class="circle-calculation">
                {{ data.value }}
              </div>
            </template>
          </b-table>
        </section>

        <hr />

        <section class="graphContainer" v-if="chartOptions">
          <apexcharts
            v-if="chartOptions.trendChart"
            :options="chartOptions.trendChart"
            height="230px"
            :series="chartOptions.trendChart.series"
          >
          </apexcharts>

          <p>
            Previsão para o próximo cálculo automático:
            <span id="nextCalc"></span>
          </p>
        </section>

        <hr />
        <b-row class="groupBtn">
          <div>
            <img
              v-if="updatedMillingsFactors"
              src="@/assets/salvar.png"
              alt="salvar"
              :title="$t('save')"
              @click="saveMillingsFactors"
            />
            <img
              v-if="showUpdateValues"
              src="@/assets/atualizar.png"
              style="margin-left: 25px"
              :title="$t('updateFactorsValue')"
              alt="atualizar"
              @click="updateMillingsFactors"
            />
            <img
              v-if="
                infoMilling.totalMilling != -9999 &&
                infoMilling.calculateMilling != -9999
              "
              src="@/assets/apagar.png"
              style="margin-left: 20px"
              :title="$t('clear')"
              alt="limpar"
              @click="resetForm"
            />
            <img
              id="closeModalPassword"
              src="@/assets/sair.png"
              style="margin-left: 15px"
              :title="$t('exit')"
              alt="Sair"
              @click="$bvModal.hide('modalFactorMillingsConfig')"
            />
          </div>
        </b-row>
      </b-overlay>
    </b-form>
  </b-card>
</template>

<script>
import { defaultSuccess, urlMainAPI } from "@/global";
import { mapState } from "vuex";
import axios from "axios";
import { FiltersMixin } from "../mixins/filtersMixin";
import { ParseToNumber } from "../flowchart/utils/tools";
import VueApexCharts from "vue-apexcharts";
import { trendChart } from "../manageAllOccurrences/utils/ChartOptions";

export default {
  name: "ModalMillingFactorConfig",
  computed: mapState(["user"]),
  components: { apexcharts: VueApexCharts },
  mixins: [FiltersMixin],
  data() {
    return {
      hourBeggin: null,
      hourEnd: null,
      diferença: 0,
      numberOfMillings: 0,
      updatedMillingsFactors: false,
      updateclicked: true,
      showUpdateValues: false,
      infoMilling: {
        totalMilling: 0,
        calculateMilling: 0,
      },
      porcentagemDiferença: 0,
      oridData: null,
      systemConfig: null,
      factors: {
        A: 0,
        B: 0,
        C: 0,
      },

      automaticGrinding: 0,

      fields: [
        { key: "dateTime", label: "Data" },
        { key: "millingcalculation", label: "Moagem Calculada" },
        { key: "millingreal", label: "Moagem Real" },
        { key: "diferenca", label: "Diferença (%)" },
        { key: "correctionfactorvalue", label: "Fator Correção" },
        { key: "typecalc", label: "Cálculo" },
      ],

      items: [],

      chartOptions: {
        trendChart: {},
        series: [],
      },

      isSaving: true,
    };
  },
  watch: {
    numberOfMillings(currentValue) {
      if (currentValue > 3) {
        this.numberOfMillings = 3;
      }
      if (currentValue < 1) {
        this.numberOfMillings = 1;
      }
    },
  },

  methods: {
    actualHour() {
      function pad(s) {
        return s < 10 ? "0" + s : s;
      }
      var date = new Date();
      let a = [date.getHours(), date.getMinutes()].map(pad).join(":");
      return a;
    },
    updatedMillingsFactorsChange() {
      this.updatedMillingsFactors = true;
    },

    async saveMillingsFactors() {
      let obj = this.systemConfig;
      this.isSaving = true;
      obj.numberOfMillings = parseInt(this.numberOfMillings);
      obj.factorA = parseFloat(this.factors.A.toString().replace(",", "."));
      obj.factorB =
        this.numberOfMillings == 2 || this.numberOfMillings == 3
          ? parseFloat(this.factors.B.toString().replace(",", "."))
          : 0;
      obj.factorC =
        this.numberOfMillings == 3
          ? parseFloat(this.factors.C.toString().replace(",", "."))
          : 0;
      obj.hourEndPeriod = this.hourEnd;

      if (this.automaticGrinding > 8) {
        this.automaticGrinding = 8;
      }

      if (this.automaticGrinding < 0) {
        this.automaticGrinding = 0;
      }

      obj.automaticGrinding = this.automaticGrinding;

      const url = `${urlMainAPI}/savesystemconfigurationMilling`;
      await axios
        .post(url, obj)
        .then(() => {
          defaultSuccess(this.$t("configuracoes-salvas-com-sucesso"));
          this.systemConfig = JSON.parse(JSON.stringify(obj));
          this.factors.A = obj.factorA;
          this.factors.B = obj.factorB;
          this.factors.C = obj.factorC;
          this.numberOfMillings = obj.numberOfMillings;
          this.updatedMillingsFactors = false;
          this.updateclicked = true;
          this.automaticGrinding = obj.automaticGrinding;
        })
        .catch();
      await this.fetchHistoricCalculationData();
      this.isSaving = false;
    },

    resetForm() {
      this.updatedMillingsFactors = false;
      this.updateclicked = true;
      let obj = JSON.parse(JSON.stringify(this.systemConfig));

      this.hourEnd = obj.hourEndPeriod;
      this.numberOfMillings = obj.numberOfMillings;
      this.factors.A = obj.factorA;
      this.factors.B = obj.factorB;
      this.factors.C = obj.factorC;
      defaultSuccess(this.$t("fatores-de-correcao-resetados"));
      this.showButtonUpdate();
    },

    async getMillingsConfigurations() {
      const url = `${urlMainAPI}/getsystemconfiguration`;
      await axios
        .get(url)
        .then((res) => {
          this.systemConfig = res.data;
          this.numberOfMillings = res.data.numberOfMillings;
          this.hourEnd = res.data.hourEndPeriod;
          this.factors.A = res.data.factorA;
          this.factors.B = res.data.factorB;
          this.factors.C = res.data.factorC;
          this.automaticGrinding = res.data.automaticGrinding;
        })
        .catch();
    },

    async getAverage8HoursMilling() {
      const url = `${urlMainAPI}/getAverage8HoursMilling`;
      await axios
        .get(url)
        .then((res) => {
          this.infoMilling.totalMilling = this.ParseNumber(
            ParseToNumber(res.data["value"])
          );
          this.infoMilling.calculateMilling = this.ParseNumber(
            ParseToNumber(res.data["target"])
          );
          this.porcentagemDiferença = this.ParseNumber(
            (1 -
              ParseToNumber(res.data["target"]) /
                ParseToNumber(res.data["value"])) *
              100
          );
        })
        .catch();
    },

    updateMillingsFactors() {
      this.factors.A = parseFloat(this.factors.A.toString().replace(",", "."));
      this.factors.B = parseFloat(this.factors.B.toString().replace(",", "."));
      this.factors.C = parseFloat(this.factors.C.toString().replace(",", "."));
      var realValue = parseFloat(this.infoMilling.totalMilling);
      var prevValue = parseFloat(this.infoMilling.calculateMilling);

      if (this.factors.A > 0)
        this.factors.A = this.ParseNumber(
          this.factors.A * (1 - prevValue / realValue) + this.factors.A
        );
      if (this.factors.B > 0)
        this.factors.B = this.ParseNumber(
          this.factors.B * (1 - prevValue / realValue) + this.factors.B
        );
      if (this.factors.C > 0)
        this.factors.C = this.ParseNumber(
          this.factors.C * (1 - prevValue / realValue) + this.factors.C
        );
      if (
        parseFloat(this.factors.A.toString().replace(",", ".")) > 0 ||
        parseFloat(this.factors.B.toString().replace(",", ".")) > 0 ||
        parseFloat(this.factors.C.toString().replace(",", ".")) > 0
      ) {
        this.updatedMillingsFactors = true;
        this.updateclicked = false;
      }
      this.showButtonUpdate();
      defaultSuccess(this.$t("fatores-de-correcao-atualizados"));
    },

    showButtonUpdate() {
      this.showUpdateValues =
        this.infoMilling.totalMilling != "-9999" &&
        this.infoMilling.calculateMilling != "-9999" &&
        parseFloat(this.infoMilling.totalMilling) > 0 &&
        this.updateclicked &&
        this.hourEnd < this.actualHour();
    },

    adjustToMidnight(dateString) {
      const date = new Date(dateString);
      date.setHours(0, 0, 0, 0);
      return date;
    },

    async fetchHistoricCalculationData() {
      const url = `${urlMainAPI}/getHistoricCalculationFactorMillings`;

      try {
        await axios
          .get(url)
          .then((response) => {
            if (
              response.status &&
              response.status == 200 &&
              response.data.length > 0
            ) {
              this.items = response.data.map((item) => ({
                ...item,
                diferenca: item.realprevratio,
              }));

              this.chartOptions.trendChart = trendChart;

              const values = response.data.map((item) => {
                return {
                  x: item.dateTime,
                  y: item.millingreal,
                  z: item.millingreal,
                };
              });
              const previstos = response.data.map((item) => {
                return {
                  x: item.dateTime,
                  y: item.millingcalculation,
                  z: item.millingcalculation,
                };
              });

              this.chartOptions.trendChart.series = [
                {
                  name: "Real",
                  data: values,
                },
                {
                  name: "Previsto",
                  data: previstos,
                },
              ];

              const initialTimestamp = new Date(
                response.data[response.data.length - 1].dateTime
              );
              const finalTimestamp = new Date(response.data[0].dateTime);

              this.chartOptions.trendChart.xaxis = {
                type: "datetime",
                min: initialTimestamp.getTime(),
                max: finalTimestamp.getTime(),
                tickAmount: 6,
                tooltip: {
                  enabled: false,
                },
                labels: {
                  datetimeUTC: false,
                },
              };
              this.previsionToNextCalc();
            }
          })
          .catch((err) => console.error(err));
      } catch (error) {
        console.error("Erro ao buscar dados: ", error);
      }
    },

    async previsionToNextCalc() {
      const url = `${urlMainAPI}/getHistoricCalculationFactorMillings`;
      const response = await axios.get(url);

      const pElement = document.getElementById("nextCalc");
      if (!pElement) return;

      const data = Array.isArray(response.data) ? response.data : [];
      const firstItem = data.find((item) => item.typecalc === "A");

      // Sem cálculo automático ainda (sem registro): deixa claro o estado em vez de campo vazio
      if (!firstItem || !firstItem.nextcalc) {
        pElement.textContent = " Aguardando coleta da moagem real (ind_real_calculoAutoMoagem) para o primeiro cálculo automático.";
        return;
      }

      const date = new Date(firstItem.nextcalc);
      date.setMinutes(date.getMinutes() + 1);

      const formattedNextCalc = `${String(date.getDate()).padStart(
        2,
        "0"
      )}/${String(date.getMonth() + 1).padStart(
        2,
        "0"
      )}/${date.getFullYear()} ${String(date.getHours()).padStart(
        2,
        "0"
      )}:${String(date.getMinutes()).padStart(2, "0")}`;

      pElement.textContent = ` ${formattedNextCalc}`;
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    },
  },

  async mounted() {
    await this.fetchHistoricCalculationData();
    await this.previsionToNextCalc();
  },

  async created() {
    this.chartOptions.trendChart = { ...trendChart };
    await this.getAverage8HoursMilling();
    await this.getMillingsConfigurations();
    this.showButtonUpdate();
    this.isSaving = false;
  },
};
</script>

<style scoped>
.card {
  padding: 5px;
}

.row {
  display: block;
}

.group-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 5px;
  width: 100%;
}

.color-button {
  margin: 0 4px 4px 0;
  color: #000;
  background-color: #fff;
  border: 1px solid #0005;
  border-radius: 4px;
}

.color-button:focus {
  outline: none;
}

.color-button:hover {
  color: #000;
  background-color: #0002;
}

.active-button {
  font-weight: 400;
  color: #fff;
  background-color: rgb(76, 175, 80);
}

.d-flex {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.not-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.d-flex > label {
  margin: 0 0 0 5px;
}

.d-flex > .lbl-click {
  cursor: pointer;
}

.d-flex.but {
  background-color: #0002;
  border: 1px solid #0002;
  color: #000;
  border-radius: 5px;
  padding: 0 5px 0 5px;
  cursor: pointer;
}

.on-active,
.off-active {
  padding: 7px;
  width: 7px;
  border-radius: 7px;
}

.on-active {
  background-color: rgb(76, 175, 80);
}

.off-active {
  background-color: #ffffff;
}

.active-button:hover {
  font-weight: 400;
  color: #fff;
  background-color: #4caf5099;
  border: 1 solid #4caf5099;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 0px;
}

img {
  cursor: pointer;
  max-height: 35px;
  margin-top: 15px;
}

input {
  float: right;
  min-width: 180px;
  width: 250px;
  text-align: center;
  border: 1px solid #ff5f00;
  border-radius: 3px;
}

input:focus {
  box-shadow: 0px 0px 5px #ff5f00;
  outline: 0;
}

.inputDataGrid {
  float: right;
  min-width: 180px;
  width: 250px;
  text-align: center;
  border: 1px solid #ff5f00;
  border-radius: 3px;
}

.inputDataGrid:focus {
  box-shadow: 0px 0px 5px #ff5f00;
  outline: 0;
}

.labelTXT {
  float: right;
}

.alertTXT {
  text-align: center;
  word-spacing: 2px;
  display: flex;
  justify-content: center;
  font-weight: bold;
  color: #0009;
}

.alertTXT2 {
  font-size: 0.8em;
}

.alertGrid {
  background-color: rgb(255, 194, 130, 0.7);
  border-radius: 5px;
  display: grid;
  grid-template-rows: auto auto;
  margin-top: 10px;
}

@media (max-width: 427px) {
  .d-flex.mobile {
    display: block !important;
  }
}

.circle-calculation {
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 50%;
  color: #fff;
  background-color: #ff5f00;
  font-weight: bold;
  font-size: smaller;
}
</style>
